export default "__VITE_ASSET__d8e7e4b8__"